module.exports = __webpack_public_path__ + "static/img/9.b5dfed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/9.jpg
// module id = qr2F
// module chunks = 1